import React, { useEffect } from 'react';
import { ClipLoader } from 'react-spinners';
import styled from 'styled-components';
import { Box } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import server from '../api/api';
import i18n from '../i18n/i18n';
import MBWayLogo from '../images/mbwayLogo.png';
import { useTheme } from '../contexts/ThemeContext';
import TopHeader from '../components/TopHeader';
import { useVendingMachine } from '../contexts/VendingMachineContext';
import { useUser } from '../contexts/UserContext';
import GalpUserMenu from '../components/GalpUserMenu';

const Message = styled.h1`
  text-align: center;
  font-size: 1.6em;
`;


function MandateRequestView({ history, location }) {
  const { mandateId, mobilePhone } = location.state || {};
  const { theme, themeName } = useTheme();
  const { vendingMachineInfo } = useVendingMachine();
  const { user } = useUser();
  const isHelexia = themeName === 'helexia';
  const isGalp = themeName === 'galp';

  const galpInitials = (() => {
    const authUser = user?.user;
    const source = authUser?.name || (authUser?.email || '').split('@')[0];
    const parts = source.split(/[\s._-]+/).filter(Boolean);
    const raw = parts.length >= 2 ? `${parts[0][0]}${parts[parts.length - 1][0]}` : (parts[0]?.[0] || '');
    return raw.toUpperCase();
  })();

  useEffect(() => {
    const handler = (event) => {
      if (event.id === mandateId) {
        if (event.state.type === 'AUTHORIZATION'
          && (event.state.statusCode === 'REJECTED'
            || event.state.statusCode === 'SUCCEEDED')) {
          history.push('/mandate-result', { mandateResult: event, mobilePhone });
        }
      }
    };

    server.onSocket('transaction_state', handler);

    return () => {
      server.offSocket('transaction_state', handler);
    };
  }, []);

  if (isGalp) {
    return (
      <div style={{
        width: '100%',
        height: '100dvh',
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        fontFamily: theme.bodyFont,
      }}
      >
        {/* Header */}
        <div style={{
          position: 'relative',
          background: '#f7f4ed',
          minHeight: '94px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 16px',
          borderBottomLeftRadius: '14px',
          borderBottomRightRadius: '14px',
          flexShrink: 0,
          boxSizing: 'border-box',
        }}
        >
          <button
            type="button"
            aria-label="back"
            onClick={() => history.goBack()}
            style={{
              position: 'absolute',
              left: '16px',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6 1L1 6L6 11"
                stroke="#0b0b0b"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <p style={{
            fontFamily: theme.titleFont,
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '24px',
            color: '#0b0b0b',
            margin: 0,
            padding: '0 40px',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
            boxSizing: 'border-box',
          }}
          >
            {vendingMachineInfo?.name || ''}
          </p>
          <GalpUserMenu initials={galpInitials} />
        </div>

        {/* Body */}
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '20px',
          padding: '40px 24px',
          overflowY: 'auto',
          boxSizing: 'border-box',
        }}
        >
          <img
            src="/companies/GALP/mbway_verify_illustration.svg"
            alt="MB WAY"
            style={{ width: '120px', height: 'auto', display: 'block' }}
          />
          <p style={{
            fontFamily: theme.bodyFont,
            fontWeight: 600,
            fontSize: '16px',
            color: '#111110',
            textAlign: 'center',
            margin: 0,
          }}
          >
            {i18n.t('verify_your_mbway_app')}
          </p>
          <p style={{
            fontFamily: theme.bodyFont,
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '22px',
            color: '#58595b',
            textAlign: 'center',
            margin: 0,
            maxWidth: '280px',
          }}
          >
            {i18n.t('approve_mandate_mbway')}
          </p>
        </div>
      </div>
    );
  }

  if (isHelexia) {
    return (
      <div style={{
        width: '100%',
        height: '100vh',
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
      >
        <TopHeader
          showVm
          userLogo
          showShadow
          history={history}
          location={location}
        />
        <div style={{
          flex: 1,
          background: '#fcfcfc',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 24px 66px',
          gap: '24px',
          overflowY: 'auto',
        }}
        >
          {/* MB WAY illustration circle */}
          <div style={{
            width: '245px',
            height: '245px',
            borderRadius: '50%',
            background: 'rgba(251, 216, 4, 0.18)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
          >
            <img src={MBWayLogo} alt="MB WAY" style={{ width: '150px', height: 'auto' }} />
          </div>

          {/* Text block */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            width: '100%',
          }}
          >
            <p style={{
              fontFamily: 'Geologica, sans-serif',
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '13px',
              letterSpacing: '-0.98px',
              color: '#014f75',
              margin: 0,
              textAlign: 'center',
            }}
            >
              {i18n.t('please')}
            </p>
            <p style={{
              fontFamily: 'Geologica, sans-serif',
              fontWeight: 600,
              fontSize: '20px',
              lineHeight: '20px',
              letterSpacing: '-0.6px',
              color: '#014f75',
              margin: 0,
              textAlign: 'center',
              whiteSpace: 'pre-line',
            }}
            >
              {i18n.t('verify_your_mbway_app')}
            </p>
          </div>

          <p style={{
            fontFamily: 'Geologica, sans-serif',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '-0.98px',
            color: '#6b6b6b',
            margin: 0,
            textAlign: 'center',
            width: '100%',
          }}
          >
            {i18n.t('approve_mandate_mbway')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      height="100%"
      margin="2vh"
    >
      <img src={MBWayLogo} alt="MB WAY" style={{ height: '20%' }} />
      <Message><b><span>{i18n.t('verify_your_mbway_app')}</span></b></Message>
      <span style={{ marginBottom: '20px' }}>{i18n.t('approve_mandate_mbway')}</span>
      <ClipLoader loading size={50} color={theme.buttonColor} />
    </Box>
  );
}

export default withRouter(MandateRequestView);
